module.exports = __webpack_public_path__ + "media/brands/liaz-7f0c808c.png";